import { newGetVulns } from 'store/Manage/filterActions';
import { getData as getAssetsData } from 'store/Host/actions';
import { getData as getKBData } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { getVulnsByAsset, getServices as getServicesInAsset } from 'store/Contextualization/AssetDetail/actions';
import {
  VULNS_SEARCH_BY_FILTER_KEYS, ASSETS_SEARCH_BY_FILTER_KEYS, KB_SEARCH_BY_FILTER_KEYS,
  VULNS_ASSETS_SEARCH_BY_FILTER_KEYS, GENERAL_ASSETS_SEARCH_BY_FILTER_KEYS,
  GENERAL_VULNS_SEARCH_BY_FILTER_KEYS,
  WORKSPACES_SEARCH_BY_FILTER_KEYS,
  GENERAL_SERVICES_SEARCH_BY_FILTER_KEYS,
  SERVICES_SEARCH_BY_FILTER_KEYS,
  SERVICES_ASSET_SEARCH_BY_FILTER_KEYS,
  SCHEDULE_SEARCH_BY_FILTER_KEYS,
  CREDENTIALS_SEARCH_BY_FILTER_KEYS,
  CLOUD_SCHEDULE_SEARCH_BY_FILTER_KEYS,
  STATUS_LOG_SEARCH_BY_FILTER_KEYS,
  RUNNERS_SEARCH_BY_FILTER_KEYS,
  SECURITY_SCANNERS_SEARCH_BY_FILTER_KEYS
} from './constants';

import { getHostsData } from 'store/HostsGeneral/actions';
import { getVulnsGeneral } from 'store/ManageGeneral/actions';
import { filterWs } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { getServicesGeneral } from 'store/ServicesGeneral/actions';
import { getServices } from 'store/Services/actions';
import { getCredentials } from 'store/Credentials/actions';
import { getCloudSchedules, getSchedules } from 'store/Schedule/actions';
import { RUNNERS_ENTITY, AGENTS_EXECUTION_ENTITY, SECURITY_SCANNERS_ENTITY, CLOUD_AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';
import { getAgentsExecutions, getCloudAgents, getUserAgents } from 'store/Agents/actions';

export const ENTITIES = {
  vulns: {
    name: {
      label: 'Vulnerabilities',
      value: 'vulns'
    },
    pathname: 'manage',
    values: VULNS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search vulnerabilities',
    advancedPlaceholder: 'e.g. {"name":"severity","op":"==","val":"critical"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: newGetVulns,
    wsDependant: true,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  assets: {
    name: {
      label: 'Assets',
      value: 'assets'
    },
    pathname: 'host',
    values: ASSETS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search assets',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getAssetsData,
    wsDependant: true,
    assetDependant: false,
    quickSearchField: 'ip',
    quickSearchFieldLabel: 'Name'
  },
  knowledgeBase: {
    name: {
      label: 'Vuln Templates',
      value: 'knowledgeBase'
    },
    pathname: 'knowledge_base',
    values: KB_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search vuln templates',
    advancedPlaceholder: 'e.g. {"name":"name","op":"ilike","val":"%SQL%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#search',
    searchFunction: getKBData,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  vulnsAssets: {
    name: {
      label: 'Vulnerabilities',
      value: 'vulnsAssets'
    },
    pathname: 'vulns',
    values: VULNS_ASSETS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search vulnerabilities',
    advancedPlaceholder: 'e.g. {"name":"severity","op":"==","val":"critical"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getVulnsByAsset,
    wsDependant: true,
    assetDependant: true,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  assetsGeneral: {
    name: {
      label: 'Assets',
      value: 'assetsGeneral'
    },
    pathname: 'hosts',
    values: GENERAL_ASSETS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search assets',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getHostsData,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'ip',
    quickSearchFieldLabel: 'Name'
  },
  vulnsGeneral: {
    name: {
      label: 'Vulnerabilities',
      value: 'vulnsGeneral'
    },
    pathname: 'vulnerabilities',
    values: GENERAL_VULNS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search vulnerabilities',
    advancedPlaceholder: 'e.g. {"name":"severity","op":"==","val":"critical"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getVulnsGeneral,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  workspaces: {
    name: {
      label: 'Workspaces',
      value: 'workspaces'
    },
    pathname: 'workspaces',
    values: WORKSPACES_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search workspaces',
    advancedPlaceholder: 'e.g. {"name":"public","op":"==","val":"true"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: filterWs,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  servicesGeneral: {
    name: {
      label: 'Services',
      value: 'servicesGeneral'
    },
    pathname: 'services',
    values: GENERAL_SERVICES_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search services',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getServicesGeneral,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  services: {
    name: {
      label: 'Services',
      value: 'services'
    },
    pathname: 'service',
    values: SERVICES_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search services',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getServices,
    wsDependant: true,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  servicesAssets: {
    name: {
      label: 'Services',
      value: 'servicesAssets'
    },
    pathname: 'services',
    values: SERVICES_ASSET_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search services',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getServicesInAsset,
    wsDependant: true,
    assetDependant: true,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  scheduler: {
    name: {
      label: 'Scheduler',
      value: 'scheduler'
    },
    pathname: 'automation/schedule',
    values: SCHEDULE_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Scheduled Runners',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getSchedules,
    wsDependant: false,
    assetDependant: false
  },
  credentials: {
    name: {
      label: 'Credentials',
      value: 'credentials'
    },
    pathname: 'credentials',
    values: CREDENTIALS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search credentials',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getCredentials,
    wsDependant: true,
    assetDependant: false,
    quickSearchField: 'username',
    quickSearchFieldLabel: 'Username'
  },
  cloudScheduler: {
    name: {
      label: 'Scheduler Cloud',
      value: 'cloudScheduler'
    },
    pathname: 'automation/schedule_cloud',
    values: CLOUD_SCHEDULE_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Scheduled Security Scanners',
    advancedPlaceholder: 'e.g. {"name":"status","op":"==","val":"open"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-vulns-aka-status-report-fields',
    searchFunction: getCloudSchedules,
    wsDependant: false,
    assetDependant: false
  },
  [RUNNERS_ENTITY]: {
    name: {
      label: 'Runners',
      value: RUNNERS_ENTITY
    },
    pathname: '/automation/agents',
    values: RUNNERS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Runners',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getUserAgents,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  [SECURITY_SCANNERS_ENTITY]: {
    name: {
      label: 'Security Scanners',
      value: SECURITY_SCANNERS_ENTITY
    },
    pathname: '/automation/agents',
    values: SECURITY_SCANNERS_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Security Scanners',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getCloudAgents,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name'
  },
  [AGENTS_EXECUTION_ENTITY]: {
    name: {
      label: 'Run Status Log',
      value: AGENTS_EXECUTION_ENTITY
    },
    pathname: '/automation/agents',
    values: STATUS_LOG_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Agents Status Log',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getAgentsExecutions,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name',
    quickSearchOp: '=='
  },
  [CLOUD_AGENTS_EXECUTION_ENTITY]: {
    name: {
      label: 'Run Status Log',
      value: CLOUD_AGENTS_EXECUTION_ENTITY
    },
    pathname: '/automation/agents',
    values: STATUS_LOG_SEARCH_BY_FILTER_KEYS,
    placeholder: 'Search Cloud Agents Status Log',
    advancedPlaceholder: 'e.g. {"name":"os","op":"ilike","val":"%Win%"}',
    documentationUrl: 'https://docs.faradaysec.com/Filters/#manage-hosts-fields',
    searchFunction: getAgentsExecutions,
    wsDependant: false,
    assetDependant: false,
    quickSearchField: 'name',
    quickSearchFieldLabel: 'Name',
    quickSearchOp: '=='
  }
};

export const SEARCH_BY_ENTITIES = [
  ENTITIES.vulns,
  ENTITIES.assets,
  ENTITIES.knowledgeBase,
  ENTITIES.vulnsAssets,
  ENTITIES.assetsGeneral,
  ENTITIES.vulnsGeneral,
  ENTITIES.workspaces,
  ENTITIES.servicesGeneral,
  ENTITIES.services,
  ENTITIES.scheduler,
  ENTITIES.credentials,
  ENTITIES.cloudScheduler,
  ENTITIES.agents,
  ENTITIES.cloudAgents,
  ENTITIES.agentExecutions,
  ENTITIES.cloudAgentExecutions
];
